import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface PhysicalCardInfoTooltipProps {
  openLeft: boolean
}

const PhysicalCardInfoTooltip: React.FC<PhysicalCardInfoTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${availableCredit} is the amount you have left to spend on your physical card.'
          }
          expressions={{
            availableCredit: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Available Credit'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default PhysicalCardInfoTooltip
